<template>
  <div class="users-page">
    <div class="filter-bar">
      <div class="search-box">
        <input 
          type="text" 
          v-model="searchKey" 
          placeholder="搜索用户名、手机号..."
          class="search-input"
        />
        <button type="button" @click="search" class="search-btn">搜索</button>
      </div>
      <div class="filter-selects">
        <select v-model="status" class="filter-select">
          <option value="">全部状态</option>
          <option value="1">正常</option>
          <option value="0">禁用</option>
        </select>
      </div>
    </div>

    <div class="table-container">
      <table class="users-table">
        <thead>
          <tr>
            <th>用户ID</th>
            <th>用户名</th>
            <th>昵称</th>
            <th>性别</th>
            <th>手机号</th>
            <th>余额</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.name }}</td>
            <td>{{ user.nickname }}</td>
            <td>{{ user.gender === 1 ? '男' : user.gender === 2 ? '女' : '未知' }}</td>
            <td>{{ user.phone }}</td>
            <td>{{ (user.balance / 100).toFixed(2) }}</td>
            <td><span :class="'status ' + (user.status === 1 ? 'status--on' : 'status--off')">{{ user.status === 1 ? '正常' : '禁用' }}</span></td>
            <td>
              <button @click="viewDetail(user.id)" class="action-btn view">查看</button>
              <button @click="openAdjustBalance(user)" class="action-btn balance">编辑余额</button>
              <button @click="toggleStatus(user)" class="action-btn" :class="user.status === 1 ? 'disable' : 'enable'">
                {{ user.status === 1 ? '禁用' : '启用' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button :disabled="currentPage === 1" @click="prevPage" class="page-btn">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页</span>
      <button :disabled="currentPage === totalPages" @click="nextPage" class="page-btn">下一页</button>
    </div>

    <!-- 编辑余额弹窗 -->
    <div v-if="showAdjustModal" class="modal-mask" @click.self="closeAdjustBalance">
      <div class="modal-box">
        <div class="modal-header">
          <span>编辑余额 - {{ adjustTarget.name }}</span>
          <button class="modal-close" @click="closeAdjustBalance">×</button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <label class="form-label">当前余额</label>
            <div class="form-control-static">{{ (adjustTarget.balance / 100).toFixed(2) }}</div>
          </div>
          <div class="form-row">
            <label class="form-label">操作类型</label>
            <div class="radio-group">
              <label class="radio-item">
                <input type="radio" value="recharge" v-model="adjustForm.type" /> 充值
              </label>
              <label class="radio-item">
                <input type="radio" value="deduct" v-model="adjustForm.type" /> 扣除
              </label>
            </div>
          </div>
          <div class="form-row">
            <label class="form-label">金额（单位：元）</label>
            <input
              type="number"
              min="0.01"
              step="0.01"
              v-model="adjustForm.amount"
              class="form-input"
              placeholder="请输入金额（单位：元）"
            />
          </div>
          <div class="form-row">
            <label class="form-label">备注</label>
            <textarea
              v-model="adjustForm.description"
              class="form-textarea"
              placeholder="请输入备注"
              rows="3"
            ></textarea>
          </div>
          <div class="form-row">
            <label class="form-label">当前操作员</label>
            <input
              type="text"
              :value="currentOperatorName"
              class="form-input operator-input"
              readonly
              :placeholder="currentOperatorName"
            />
          </div>
          <p v-if="adjustError" class="form-error">{{ adjustError }}</p>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeAdjustBalance">取消</button>
          <button class="btn-confirm" :disabled="adjustSubmitting" @click="submitAdjustBalance">
            {{ adjustSubmitting ? '提交中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserList, adjustUserBalance } from '@/api'
export default {
  name: 'Users',
  data() {
    return {
      searchKey: '',
      status: '',
      currentPage: 1,
      totalPages: 10,
      users: [],
      showAdjustModal: false,
      adjustTarget: {},
      adjustForm: {
        type: 'recharge',
        amount: 0.00,
        description: ''
      },
      adjustSubmitting: false,
      adjustError: ''
    }
  },
  computed: {
    currentOperatorName() {
      const user = this.$store.state.user.user
      if (!user) return ''
      return user.real_name || user.username || ''
    }
  },
  mounted() {
    this.loadUsers()
  },
  watch: {
    status() {
      this.currentPage = 1
      this.loadUsers(1)
    }
  },
  methods: {
    search() {
      this.currentPage = 1
      this.loadUsers(1)
    },
    async loadUsers(page = 1) {
      try {
        const params = {
          page,
          pageSize: 10
        }
        // 只在有值时传递搜索参数
        if (this.searchKey) {
          params.search = this.searchKey
        }
        if (this.status) {
          params.status = this.status
        }
        
        const response = await getUserList(params)
        
        if (response && response.data) {
          const paginationData = response.data
          // Laravel paginate 返回的数据在 data 字段中
          const usersList = paginationData.data || []
          
          this.users = usersList.map(user => ({
            id: user.id,
            name: user.name || '',
            nickname: user.nickname || '',
            gender: user.gender || 0,
            phone: user.phone || '',
            balance: user.wallet ? user.wallet.balance : 0,
            status: user.status
          }))
          
          // 分页信息
          this.totalPages = paginationData.last_page || Math.ceil(paginationData.total / paginationData.per_page) || 1
        }
      } catch (error) {
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.loadUsers(this.currentPage)
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.loadUsers(this.currentPage)
      }
    },
    viewDetail(id) {
      this.$router.push(`/user/users/detail/${id}`)
    },
    toggleStatus(user) {
      const action = user.status === 1 ? '禁用' : '启用'
      if (confirm(`确定要${action}用户 ${user.name} 吗？`)) {
        user.status = user.status === 1 ? 0 : 1
      }
    },
    openAdjustBalance(user) {
      this.adjustTarget = user
      this.adjustForm = {
        type: 'recharge',
        amount: 0.00,
        description: ''
      }
      this.adjustError = ''
      this.showAdjustModal = true
    },
    closeAdjustBalance() {
      this.showAdjustModal = false
    },
    async submitAdjustBalance() {
      this.adjustError = ''
      const amount = parseFloat(this.adjustForm.amount)
      if (!amount || amount <= 0) {
        this.adjustError = '请输入大于 0 的金额'
        return
      }
      this.adjustSubmitting = true
      try {
        const res = await adjustUserBalance(this.adjustTarget.id, {
          type: this.adjustForm.type,
          // 单位保持「元」，由后端统一转换为「分」后写入
          amount: amount,
          description: this.adjustForm.description
        })
        const newBalance = res && res.data ? res.data.balance : null
        if (newBalance !== null && newBalance !== undefined) {
          this.adjustTarget.balance = newBalance
        } else {
          this.loadUsers(this.currentPage)
        }
        this.showAdjustModal = false
        alert('操作成功')
      } catch (error) {
        this.adjustError = (error.response && error.response.data && error.response.data.message) || '操作失败，请重试'
      } finally {
        this.adjustSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.users-page {
  padding: 20px;
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.search-box {
  display: flex;
  gap: 10px;
}

.search-input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  width: 250px;
}

.search-btn {
  padding: 10px 20px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.filter-selects {
  display: flex;
  gap: 15px;
  align-items: center;
}

.filter-select {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
}

.users-table th, .users-table td {
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.users-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.status {
  padding: 4px 0;
  border-radius: 20px;
  font-size: 12px;
}

.status--on { background: #e8f5e9; color: #2ecc71; }
.status--off { background: #ffebee; color: #e74c3c; }

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 5px;
}

.action-btn.view {
  background: #3498db;
  color: #fff;
}

.action-btn.disable {
  background: #e74c3c;
  color: #fff;
}

.action-btn.enable {
  background: #2ecc71;
  color: #fff;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.action-btn.balance {
  background: #f39c12;
  color: #fff;
}

/* 编辑余额弹窗 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  width: 420px;
  max-width: 92%;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 15px;
}

.modal-close {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 20px;
}

.form-row {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  color: #555;
}

.form-control-static {
  font-size: 18px;
  font-weight: 600;
  color: #e67e22;
}

.radio-group {
  display: flex;
  gap: 24px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  cursor: pointer;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}

.form-input:focus,
.form-textarea:focus {
  border-color: #3498db;
}

.operator-input {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.form-error {
  color: #e74c3c;
  font-size: 13px;
  margin: 0 0 8px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel,
.btn-confirm {
  padding: 9px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #ddd;
}

.btn-cancel {
  background: #fff;
  color: #555;
}

.btn-confirm {
  background: #3498db;
  color: #fff;
  border-color: #3498db;
}

.btn-confirm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>